import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";
import router from '../../../router'

export const fetchShipmentPartnerList = ({commit, dispatch}, payload) => {
    commit('toggleLoadingState', true)
    axios.post('/shipmentPartners/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        if(res.data.try_again) {
            dispatch('fetchShipmentPartnerList', payload)
        } else {
            commit('setShipmentPartnerList', res.data.response)         
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const fetchShipmentPartnerData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/shipmentPartners/single.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            if(payload.copy) {
                res.data.response.id = 0
                commit('displaySuccessNotification', {message: 'Data copied!!!'});                
            }
            
            commit('setShipmentPartnerData', {response: res.data.response, copy: payload.copy})   
            if(payload.navigate) {
                router.push(router.currentRoute.fullPath+'/form/')
            }

        } else {
            commit('resetShipmentPartnerData')
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const submitShipmentPartnerData = ({commit}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/shipmentPartners/save.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data submitted successfully!!!'});
            router.push(router.currentRoute.fullPath.replace('/form/', ''))
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}

export const deleteShipmentPartnerData = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/shipmentPartners/delete.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            commit('displaySuccessNotification', {message: 'Data deleted successfully!!!'});
            if(payload.navBack) {
                router.push(router.currentRoute.fullPath.replace('/form/', ''))
            } else {
                dispatch('fetchShipmentPartnerList')
            }
            
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
}


// WEBPACK FOOTER //
// ./src/store/modules/shipmentPartner/actions.js